import { defineComponent } from 'vue';
import {FilterService, FilterMatchMode, FilterOperator} from 'primevue/api';
import ObjectUtils from 'primevue/utils/ObjectUtils';

export default defineComponent({
    data() {
        return {
            /** The following data is implemented in entriesCommonMixin.js
             * entriesMap: {},
             * renderedEntriesMap: {},
             * fieldValuesMap: {},
             */
        }
    },
    computed: {
        renderedEntries() {
            return Object.values(this.renderedEntriesMap);
        }
    },
    methods: {
        /** Copied and adapted from DataTable.vue */
        filter(data) {
            if (!data) {
                return;
            }

            let globalFilterFieldsArray;
            if (this.filters['global']) {
                globalFilterFieldsArray = Object.keys(this.filters);
            }

            let filteredValue = [];

            for (let i = 0; i < data.length; i++) {
                let localMatch = true;
                let globalMatch = false;
                let localFiltered = false;

                for (let prop in this.filters) {
                    if (Object.prototype.hasOwnProperty.call(this.filters, prop) && prop !== 'global') {
                        localFiltered = true;
                        let filterField = prop;
                        let filterMeta = this.filters[filterField];

                        if (filterMeta.operator) {
                            for (let filterConstraint of filterMeta.constraints) {
                                localMatch = this.executeLocalFilter(filterField, data[i], filterConstraint);

                                if ((filterMeta.operator === FilterOperator.OR && localMatch) || (filterMeta.operator === FilterOperator.AND && !localMatch)) {
                                    break;
                                }
                            }
                        }
                        else {
                            localMatch = this.executeLocalFilter(filterField, data[i], filterMeta);
                        }

                        if (!localMatch) {
                            break;
                        }
                    }
                }

                if (this.filters['global'] && !globalMatch && globalFilterFieldsArray) {
                    for(let j = 0; j < globalFilterFieldsArray.length; j++) {
                        let globalFilterField = globalFilterFieldsArray[j];
                        globalMatch = FilterService.filters[this.filters['global'].matchMode || FilterMatchMode.CONTAINS](ObjectUtils.resolveFieldData(data[i], globalFilterField), this.filters['global'].value, this.filterLocale);

                        if (globalMatch) {
                            break;
                        }
                    }
                }

                let matches;
                if (this.filters['global']) {
                    matches = localFiltered ? (localFiltered && localMatch && globalMatch) : globalMatch;
                }
                else {
                    matches = localFiltered && localMatch;
                }

                if (matches) {
                    filteredValue.push(data[i]);
                }
            }

            /*if (filteredValue.length === this.entries.length) {
                filteredValue = data;
            }*/

            return filteredValue;
        },
        /** Copied and adapted from DataTable.vue */
        executeLocalFilter(field, rowData, filterMeta) {
            let filterValue = filterMeta.value;
            let filterMatchMode = filterMeta.matchMode || FilterMatchMode.STARTS_WITH;
            let dataFieldValue = ObjectUtils.resolveFieldData(rowData, field);
            let filterConstraint = FilterService.filters[filterMatchMode];

            return filterConstraint(dataFieldValue, filterValue, Laravel.activeLocale);
        },
        setRenderedEntriesMap() {
            const filteredEntries = this.filter(this.entriesWithOptionalHidden);
            const tempEntriesMap = {};

            filteredEntries.forEach(entry => tempEntriesMap[entry.id] = entry);
            this.renderedEntriesMap = tempEntriesMap;
        }
    },
    watch: {
        entriesWithOptionalHidden() {
            this.setRenderedEntriesMap();
        },
        filters: {
            handler() {
                this.setRenderedEntriesMap();
            },
            deep: true
        }
    }
});
